import React, { useState } from 'react';

const IconButtonCont = ({ data,setVisibleMessage,setVisibleFile,visibleMessage,visibleFile }) => {
    return (
        <div className="icon-button-cont">
            <div className="tool-tip-cont">
                <div className="tool-tip">Հաղորդագրություններ</div>
                <div className="icon-button"
                     onClick={() => setVisibleMessage(!visibleMessage)}>
                    <div className="add-file">
                        <i className="fas fa-envelope" />
                        {!visibleMessage && data?.new_sms_count !== 0 ? (
                            <div className="tasks-around">{data?.new_sms_count}</div>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="tool-tip-cont">
                <div className="icon-button"
                     onClick={() => setVisibleFile(!visibleFile)}>
                    <div className="tool-tip">Ֆայլերի ցանկ</div>
                    <div className="add-file">
                        <i className="fas fa-file" />
                        {data?.new_file_count !== 0 ? (
                            <div className="tasks-around">{data?.new_file_count}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IconButtonCont;
